import React from "react";
import { useSearchParams } from "react-router-dom";
import AcceptUserInviteModal from "../../../components/pages/Users/modal/acceptInvitationModal";

const AcceptInvitePage = () => {
    const [searchParams] = useSearchParams();
    const view = searchParams.get("view");

    const showModal = view === "accept";

    return (
        <div className="relative w-full h-screen">
            {showModal && (
                <>
                    {/* bg video */}
                    <video
                        className="absolute inset-0 w-full h-full object-cover"
                        autoPlay
                        muted
                        loop
                        playsInline
                    >
                        <source src="/videos/Fleetrify-Bgss.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>

                    <div className="absolute inset-0 bg-black opacity-50"></div>

                    <div className="relative z-20 flex items-center justify-center w-full h-full">
                        <AcceptUserInviteModal />
                    </div>
                </>
            )}
        </div>
    );
};

export default AcceptInvitePage;
